import ErrorPageContext from '@contexts/errorPageContext'
import { useContext } from 'react'

const useIsErrorPage = (): boolean => useContext(ErrorPageContext)

export default useIsErrorPage
